import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

export interface GameHeaderProps extends SharedProps {
  title: string
  media?: string
  descriptionHtml?: string
  textColor?: string
  backgroundColor?: string
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/game-header](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/game-header)
 * - Storybook: [GameHeader](https://designsystem.dn.se/?path=/docs/section-Gameheader--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/game-header/game-header.scss'`
 */
export const GameHeader = ({
  title,
  media,
  descriptionHtml,
  classNames,
  backgroundColor,
  textColor,
  attributes,
}: GameHeaderProps) => {
  const componentClassName = 'ds-game-header'

  const classes = formatClassString([componentClassName, classNames])

  const styles = {
    color: textColor,
    backgroundColor,
  }

  return (
    <div className={classes} {...attributes}>
      <div className={`${componentClassName}__top`} style={styles}>
        <div className={`${componentClassName}__top-content`}>
          <h1 className={`${componentClassName}__title`}>{title}</h1>
          {media && <div className={`${componentClassName}__media`} dangerouslySetInnerHTML={{ __html: media }}></div>}
        </div>
      </div>

      {descriptionHtml && (
        <div className={`${componentClassName}__description`}>
          <div
            className={`${componentClassName}__description-content`}
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          ></div>
        </div>
      )}
    </div>
  )
}
